module.exports = __webpack_public_path__ + "static/media/category.f98fa141.svg";